module.exports = __webpack_public_path__ + "img/hsa-store-logo.cf98a617.png";